import Vue, { computed, Ref, ref } from 'vue';
import { hasPermission, Permissions } from '@/ui/auth/auth';
import { AssetsPhotoActions } from '@/services/assets-api/AssetsPhotoService';

export function useQuestionOptions(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: Ref<any>,
  inspection: Ref<{
    entity_items: Record<string, string>;
    issues: Record<string, string>;
  }>,
  instance: { proxy: Vue } | null,
) {
  const isRaiseIssueModalVisible = ref(false);

  const showNotes = () => {
    instance?.proxy?.$store.commit('conduct/showNotesModal', item.value);
  };

  const showPhotos = () => {
    instance?.proxy?.$store.commit('conduct/showPhotosModal', item.value);
  };

  const raiseIssueButtonClicked = () => {
    isRaiseIssueModalVisible.value = true;
  };

  const raiseIssueModalClosed = () => {
    isRaiseIssueModalVisible.value = false;
  };

  const containsPhotos = computed(() => item.value.photos
    && item
      .value
      .photos
      .filter((photo: { action: AssetsPhotoActions}) => photo.action !== AssetsPhotoActions.DELETE_IMAGE)
      .length > 0);

  const issues = computed(() => typeof inspection.value.issues === 'object'
    ? Object.values(inspection.value.issues)
    : inspection.value.issues);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const raisedIssues = computed(() => issues.value?.find((row: any) => {
    const splitUuid = row.inspection_question_uuid ? row.inspection_question_uuid.split('-') : [];
    const uuid = splitUuid.slice(1, 6).join('-');

    return uuid === item.value.uuid;
  }));

  const newIssues = computed(() => typeof inspection.value.issues === 'object'
    ? Object.keys(inspection.value.issues)?.find(uuid => uuid === item.value.uuid)
    : null);

  const containsIssues = computed(() => {
    return raisedIssues.value || newIssues.value;
  });

  const notesIconFill = computed(() => {
    if (item.value.notes) {
      return 'text-primary';
    }
    return 'text-60';
  });

  const photosIconFill = computed(() => {
    if (containsPhotos.value) {
      return 'text-primary';
    }
    return 'text-60';
  });

  const issuesAllowed = computed(() => {
    return item.value.issues_allowed !== false && hasPermission(Permissions.CREATE_ISSUE);
  });

  const raiseIssueButtonClasses = computed(() => ({
    'text-60': !containsIssues.value,
    'text-primary': containsIssues.value,
  }));

  return {
    isRaiseIssueModalVisible,
    showNotes,
    showPhotos,
    raiseIssueButtonClicked,
    raiseIssueModalClosed,
    containsPhotos,
    containsIssues,
    notesIconFill,
    photosIconFill,
    issuesAllowed,
    raiseIssueButtonClasses,
    raisedIssues,
    newIssues,
  };
}
